import { VIP_PARTNER } from '../../../constants/system-roles';
import { getRoleAdjustedUrl } from './getIndustryReportsPageUrlService';

export const getAdjustedBreadcrumbPathItems = (pathItems, userRoleId) => {
  if (!pathItems || pathItems.length === 0) {
    return pathItems;
  }

  const items = [...pathItems];
  if (userRoleId === VIP_PARTNER) {
    items.shift();
  }

  return items.map(path => {
    return {
      name: path.name,
      url: getRoleAdjustedUrl(path.url, userRoleId)
    };
  });
};
